import { render, staticRenderFns } from "./NmicNosologiaPage.vue?vue&type=template&id=1d91ac9c&"
import script from "./NmicNosologiaPage.vue?vue&type=script&lang=js&"
export * from "./NmicNosologiaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports